(() => {
  'use strict';

  const initializeSlider = (root) => {
    if (!root || root.dataset.msxSliderReady === 'true') return;
    root.dataset.msxSliderReady = 'true';

    const track = root.querySelector('[data-msx-product-track]');
    const controls = root.querySelector('[data-msx-product-controls]');
    const previous = root.querySelector('[data-msx-product-prev]');
    const next = root.querySelector('[data-msx-product-next]');
    if (!track) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const overflowTolerance = 2;

    const cardStep = () => {
      const card = track.querySelector('.msx-product-card');
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const hasOverflow = track.scrollWidth > track.clientWidth + overflowTolerance;
      if (controls) controls.hidden = !hasOverflow;
      if (!hasOverflow) {
        track.scrollLeft = 0;
        return;
      }
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (previous) previous.disabled = track.scrollLeft <= overflowTolerance;
      if (next) next.disabled = track.scrollLeft >= maxScroll - overflowTolerance;
    };

    const scroll = (direction) => {
      track.scrollBy({
        left: direction * cardStep(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    };

    previous?.addEventListener('click', () => scroll(-1));
    next?.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', updateControls, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateControls);
      observer.observe(track);
    } else {
      window.addEventListener('resize', updateControls, { passive: true });
    }

    updateControls();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-msx-product-slider]').forEach(initializeSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
